import { gql } from 'src/generated/gql';

export const FLOW_MAPPINGS_QUERY = gql(`
  query FlowMappings($kind: String!) {
    flowMappingsByKind(kind: $kind) {
      interactionKey
    }
  }
`);
